<script>
import { getClientType } from '@utils/client'
import * as link from '@utils/link'
import { mapState } from 'vuex'

export default {
  components: {},
  data() {
    return {
      view: window.innerWidth > 767 ? 'pc' : 'sp',
      urlLogout: '',
      urlLogin: '',
      jafnaviTop:
        process.env.NODE_ENV === 'production'
          ? link.JAF_NAVI_TOP
          : link.JAF_NAVI_TOP_TEST,
      jafnaviDrive:
        process.env.NODE_ENV === 'production'
          ? link.JAF_NAVI_DRIVE
          : link.JAF_NAVI_DRIVE_ST,
      jafnaviEvent:
        process.env.NODE_ENV === 'production'
          ? link.JAF_NAVI_EVENT
          : link.JAF_NAVI_EVENT_TEST,
      jafnaviPresent:
        process.env.NODE_ENV === 'production'
          ? link.JAF_NAVI_PRESENT
          : link.JAF_NAVI_PRESENT_TEST,
      jafnaviShopping:
        process.env.NODE_ENV === 'production'
          ? link.JAF_NAVI_SHOPPING
          : link.JAF_NAVI_SHOPPING_TEST,
      jafnaviGuide:
        process.env.NODE_ENV === 'production'
          ? link.JAF_NAVI_GUIDE
          : link.JAF_NAVI_GUIDE_TEST,
      jafnaviJoinGuide:
        process.env.NODE_ENV === 'production'
          ? link.JAF_NAVI_JOIN_GUIDE
          : link.JAF_NAVI_JOIN_GUIDE_TEST,
      jafnaviFAQ:
        process.env.NODE_ENV === 'production'
          ? link.JAF_NAVI_FAQ
          : link.JAF_NAVI_FAQ_TEST,
      jafnaviSitemap:
        process.env.NODE_ENV === 'production'
          ? link.JAF_NAVI_SITEMAP
          : link.JAF_NAVI_SITEMAP_TEST,
      jafTop:
        process.env.NODE_ENV === 'production'
          ? link.JAF_TOP
          : link.JAF_TOP_TEST,
      jafnaviMyPage:
        process.env.NODE_ENV === 'production'
          ? link.JAF_NAVI_MY_PAGE
          : link.JAF_NAVI_MY_PAGE_TEST,
    }
  },
  computed: {
    viewClass() {
      if (this.view === 'pc') {
        if (this.$route.path.indexOf('search-result') > 0 ||
            this.$route.path.indexOf('brand-facility') > 0 ||
            this.$route.path.indexOf('searchTag-facility') > 0 ||
            this.$route.path.indexOf('facility-detail') > 0 ||
            this.$route.path.indexOf('newend-facility') > 0
            ) {
          if(this.isLinksMode)
          {
            return 'pc view_pc fixed_header_wrapper header_none_mode'
          }
          else {
            return 'pc view_pc fixed_header_wrapper'
          }
        } else {
          return 'pc view_pc'
        }
      } else {
        return 'sp view_sp'
      }
    },
    fixed_head() {
      if (this.$route.path.indexOf('search-result') > 0 ||
        this.$route.path.indexOf('brand-facility') > 0 ||
        this.$route.path.indexOf('searchTag-facility') > 0 ||
        this.$route.path.indexOf('genre') > 0 ||
        this.$route.path.indexOf('sub-genre') > 0 ||
        this.$route.path.indexOf('facility-area') > 0 ||
				this.$route.path.indexOf('facility-prefecture') > 0 ||
				this.$route.path.indexOf('facility-municipality') > 0 ||
        this.$route.path.indexOf('facility-detail') > 0 ||
        this.$route.path.indexOf('newend-facility') > 0 ) {
        return 'fixed_header'
      } else {
        return ''
      }
    },
    headerClass() {
      if (this.$route.path.indexOf('search-result') > 0 ) {
        return 'navbar-brand fixed_header'
      } else {
        return 'navbar-brand'
      }
    },
    fileLogo() {
      if (this.view === 'pc') {
        return (
          this.$store.state.env.basepath + 'img/jaf/logo_jafnavi_yuutai.svg'
        )
      } else {
        return this.$store.state.env.basepath + 'img/jaf/logo_jafnavi.svg'
      }
    },
    loginId() {
      if (this.view === 'pc') {
        return 'loggedin_pc'
      } else {
        return 'loggedin_sp'
      }
    },
    buttonLogoutId() {
      if (this.view === 'pc') {
        return 'btn_logout_pc'
      } else {
        return 'btn_logout_sp'
      }
    },
    buttonLoginId() {
      if (this.view === 'pc') {
        return 'btn_login_pc'
      } else {
        return 'btn_login_sp'
      }
    },
    buttonJoinId() {
      if (this.view === 'pc') {
        return 'btn_join_pc'
      } else {
        return 'btn_join_sp'
      }
    },
    navLoginItemClass() {
      if (this.view === 'pc') {
        return 'navbar-item login_status pc'
      } else {
        return 'navbar-item login_status sp'
      }
    },
    navjoinItemClass() {
      if (this.view === 'pc') {
        return 'navbar-item pc'
      } else {
        return 'navbar-item sp'
      }
    },
    navItemClass() {
      if (this.view === 'pc') {
        return 'navbar-item x-link pc'
      } else {
        return 'navbar-item x-link sp'
      }
    },
    navHowtoId() {
      if (this.view === 'pc') {
        return 'nav_howto_pc'
      } else {
        return 'nav_howto_sp'
      }
    },
    navFaqId() {
      if (this.view === 'pc') {
        return 'nav_faq_pc'
      } else {
        return 'nav_faq_sp'
      }
    },
    navSitemapId() {
      if (this.view === 'pc') {
        return 'nav_sitemap_pc'
      } else {
        return 'nav_sitemap_sp'
      }
    },
    navSearchId() {
      if (this.view === 'pc') {
        return 'nav_search_pc'
      } else {
        return 'nav_search_sp'
      }
    },
    navMypageId() {
      if (this.view === 'pc') {
        return 'nav_mypage_pc'
      } else {
        return 'nav_mypage_sp'
      }
    },
    loginUrl() {
      // const encoded = escape(decodeURI(location.href))
      const url = `${process.env.VUE_APP_SSO_URL}?qServiceId=${
        process.env.VUE_APP_SSO_ID
      }&qUrl=${encodeURIComponent(decodeURI(location.href))}`
      // const encodeUrl = encodeURI(url)
      return url
    },
    isLinksMode() {
      if (this.$store.state.auth.userType == '80' && this.$store.state.auth.loggedIn) {
        return true
      }

      return false
    },
    ...mapState({
      isLogin: (state) => state.auth.loggedIn,
      basepath: (state) => state.env.basepath,
    }),
  },
  methods: {
    login() {
      // this.$store.dispatch('auth/simpleLogin')
      event.preventDefault()
      location.href = this.loginUrl
    },
    logout() {
      event.preventDefault()
      this.$store.dispatch('auth/logoutReload')
    },
  },
}
</script>

<template>
  <div v-if="!isLinksMode" id="headerWrap" :class="viewClass">
    <header
      id="head"
      :class="['navbar', 'container', fixed_head]"
      role="navigation"
      aria-label="main navigation"
    >
      <div :class="headerClass">
        <h1 class="logo">
          <a class="navbar-item" :href="jafnaviTop">
            <img :src="fileLogo" alt="JAFナビ"/> </a>
        </h1>
        <div class="navbar-burger burger">
          <ul class="login_box">
            <template v-if="isLogin">
              <li :id="buttonLogoutId" class="navbar-item">
                <a class="guide" href="javascript:void(0);" @click="logout">
                  <span class="icon"><i class="fas fa-sign-out-alt"></i></span><span class="txt_wicon">ログアウト</span>
                </a>
              </li>
            </template>
            <template v-else>
              <li :id="buttonLoginId" class="navbar-item">
                <a class="login" href="javascript:void(0);" @click="login">
                  <span class="icon"><i class="fas fa-unlock-alt"></i></span><span class="txt_wicon">ログイン</span>
                </a>
              </li>
            </template>
          </ul>
          <a role="button" class="x-navbar-burger x-burger" aria-label="menu" aria-expanded="false" data-target="global">
            <div class="btn_menu">
              <span class="icon"><i class="fa fa-bars"></i></span><span class="txt_wicon">メニュー</span>
            </div>
          </a>
        </div>
      </div>
      <div class="navbar-menu">
        <div class="navbar-end navbar-menu">
          <div id="headPrimary">
            <ul class="navbar-item">
              <li :id="navMypageId" :class="navItemClass">
                <a :href="jafnaviMyPage" target="_blank">
                  <span class="icon"><i class="fas fa-user"></i></span><span class="txt_wicon">マイページ</span><i class="fas fa-chevron-right sp"></i>
                </a>
              </li>
              <li :id="navHowtoId" :class="navItemClass">
                <a :href="jafnaviGuide">
                  <span class="icon">
                    <span class="fa-stack fa-1x">
                      <i class="fas fa-square fa-stack-2x"></i>
                      <i class="fas fa-info fa-stack-1x fa-sm fa-inverse"></i>
                    </span>
                  </span>
                  <span class="txt_wicon">会員優待のご利用方法</span>
                  <i class="fas fa-chevron-right sp"></i>
                </a>
              </li>
              <li :id="navFaqId" :class="navItemClass">
                <a :href="jafnaviFAQ" target="_blank">
                  <span class="icon">
                    <span class="fa-stack fa-1x">
                      <i class="fas fa-square fa-stack-2x"></i>
                      <i class="fas fa-question fa-stack-1x fa-sm fa-inverse"></i>
                    </span>
                  </span>
                  <span class="txt_wicon">よくあるご質問</span>
                  <i class="fas fa-chevron-right sp"></i>
                </a>
              </li>
              <li :id="navSitemapId" :class="navItemClass">
                <a :href="jafnaviSitemap">
                  <span class="icon">
                    <i class="fas fa-sitemap"></i>
                  </span>
                  <span class="txt_wicon">サイトマップ</span>
                  <i class="fas fa-chevron-right sp"></i>
                </a>
              </li>
              <li class="navbar-item sublogo logo">
                <a :href="jafTop" target="_blank">
                  <img :src="`${basepath}img/jaf/logo_jaf.svg`" alt="JAF" />
                </a>
              </li>
            </ul>
          </div>
          <ul id="headSecondary" class="navbar-item">
            <li class="login_box">
              <ul class="navbar-item">
                <li id="faq158604" class="navbar-item faq158604">
                  <a href="https://support.jaf.or.jp/faq/show/308" target="_blank">
                    <span class="icon">
                      <i class="fas fa-exclamation-triangle"></i>
                    </span>
                    <span class="txt_wicon">ログインについて</span>
                  </a>
                </li>
                <template v-if="isLogin">
                  <li :id="loginId" :class="navLoginItemClass">
                    <span class="">ログイン中</span>
                  </li>
                  <li :id="buttonLogoutId" class="navbar-item">
                    <a class="guide" href="javascript:void(0);" @click="logout">
                      <span class="icon"><i class="fas fa-sign-out-alt"></i></span><span class="txt_wicon">ログアウト</span>
                    </a>
                  </li>
                </template>
                <template v-else>
                  <li :id="buttonLoginId" class="navbar-item">
                    <a class="login" href="javascript:void(0);" @click="login">
                      <span class="icon"><i class="fas fa-unlock-alt"></i></span><span class="txt_wicon">ログイン</span>
                    </a>
                  </li>
                  <li :id="buttonJoinId" :class="navjoinItemClass">
                    <a class="ga_event_btn_join guide" :href="jafnaviJoinGuide" target="_blank">
                      <span class="icon"><i class="fas fa-id-card"></i></span><span class="txt_wicon">JAFに入会する</span>
                    </a>
                  </li>
                </template>
              </ul>
            </li>
            <li :id="navSearchId" class="search_box search">
              <span class="navbar-item">
                <div id="qsWidgetHead" class="search_window" data-host-qs="jafnavi.jp"></div>
              </span>
            </li>
            <!-- <script src="<?php echo getAssetWithParameter(ROOT_DIR.'/common/js/widgetQs.js'); ?>"></script> -->
          </ul>
        </div>
      </div>
    </header>
    <nav
      id="global"
      class="navbar container x-is-fixed-top"
      role="navigation"
      aria-label="global navigation"

    >
      <!-- <?php if( (isset($styleBody) && in_array('rwd', $styleBody)) || (VIEW=='sp') ){ ?> -->
      <div v-if="view === 'sp'" class="navbar-menu menu-label sp">
        <!-- span class="navbar-item"><span class="icon"><i class="fas fa-bars"></i></span><span class="txt_wicon">メニュー</span></span -->
        <span class="btn_close navbar-item"
          ><span class="icon"><i class="fas fa-window-close"></i></span
          ><span class="txt_wicon">閉じる</span></span
        >
      </div>
      <!-- <?php } ?> -->
      <ul class="navbar-menu menu-main">
        <!-- <?php
$html_sp->outputSearch(); ?> -->
        <li id="nav_search_sp" class="navbar-item search_box sp">
          <div class="search_window" id="qsWidgetMenuSp" data-host-qs="test.jafnavi.jp"></div>
        </li>
        <li id="nav_home" class="navbar-item">
          <a :href="jafnaviTop">
            <span class="icon"><i class="fas fa-home"></i></span>ホーム<i class="fas fa-chevron-right sp"></i>
          </a>
        </li>
        <li id="nav_membership" class="navbar-item">
          <a href="/?from_navigation=1">
            <span class="icon"><i class="fas fa-crown"></i></span>会員優待<i class="fas fa-chevron-right sp"></i>
          </a>
        </li>
        <li id="nav_driveguide" class="navbar-item">
          <a :href="jafnaviDrive">
            <span class="icon"><i class="fas fa-car"></i></span>ドライブ・イベント<i class="fas fa-chevron-right sp"></i>
          </a>
        </li>
        <li id="nav_present" class="navbar-item">
          <a :href="jafnaviPresent">
            <span class="icon"><i class="fas fa-gift"></i></span>プレゼント<i class="fas fa-chevron-right sp"></i>
          </a>
        </li>
        <li id="nav_mypage_sp" class="navbar-item x-link sp">
          <a :href="jafnaviMyPage" target="_blank">
            <span class="icon"><i class="fas fa-user"></i></span>
            <span class="txt_wicon">マイページ</span><i class="fas fa-chevron-right sp">
            </i>
          </a>
        </li>
        <li id="nav_howto_sp" class="navbar-item x-link sp">
          <a :href="jafnaviGuide">
            <span class="icon">
              <span class="fa-stack fa-1x"><i class="fas fa-square fa-stack-2x"></i><i class="fas fa-info fa-stack-1x fa-sm fa-inverse"></i></span>
            </span>
            <span class="txt_wicon">会員優待のご利用方法</span><i class="fas fa-chevron-right sp"></i>
          </a>
        </li>
        <li id="nav_faq_sp" class="navbar-item x-link sp">
          <a :href="jafnaviFAQ" target="_blank">
            <span class="icon">
              <span class="fa-stack fa-1x">
                <i class="fas fa-square fa-stack-2x"></i><i class="fas fa-question fa-stack-1x fa-sm fa-inverse"></i>
              </span>
            </span>
            <span class="txt_wicon">よくあるご質問</span><i class="fas fa-chevron-right sp"></i>
          </a>
        </li>
        <li id="nav_sitemap_sp" class="navbar-item x-link sp">
          <a :href="jafnaviSitemap">
            <span class="icon"><i class="fas fa-sitemap"></i></span>
            <span class="txt_wicon">サイトマップ</span>
            <i class="fas fa-chevron-right sp"></i>
          </a>
        </li>
        <!-- <?php
if((isset($styleBody) && (in_array('rwd', $styleBody)||in_array('ua', $styleBody)))){
	$html_sp->outputPrimary(); } ?> -->
      </ul>
    </nav>
  </div>
  <div v-else id="headerWrap" :class="viewClass" >
  </div>
</template>

<style lang="scss" scoped>
#nav_membership a {
  background: #d80038;
  color: #ffffff;
}
#nav_membership a .icon {
  color: #ffffff;
}
#headerWrap.header_none_mode {
  background-color: #ffffff;
}
</style>
